import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useSignIn } from '@clerk/clerk-react'
import Loading from '@/components/Loading'
import { useRedirectToLastUrl } from '@/hooks/useRedirectToLastUrl'

function SsoCallback() {
  const { created_session_id } = Route.useSearch()
  const navigate = useNavigate()
  const { isLoaded, setActive = () => undefined, signIn } = useSignIn()
  useRedirectToLastUrl()

  useEffect(() => {
    if (!isLoaded) return

    const func = async () => {
      if (created_session_id) {
        await setActive({ session: created_session_id })
      } else {
        await signIn.reload()
        const { status, firstFactorVerification } = signIn

        if (status === 'complete' && signIn.createdSessionId) {
          await setActive({ session: signIn.createdSessionId })
        } else if (firstFactorVerification.status === 'transferable') {
          await navigate({ to: '/signup', replace: true })
        } else {
          throw new Error('SSO Callback Error: cannot sign in and not transferable')
        }
      }
    }

    void func().catch((error) => console.error(error))
  }, [created_session_id, isLoaded])

  return <Loading />
}

export const Route = createFileRoute('/sso-callback')({
  validateSearch: (search: Record<string, unknown>) => ({
    created_session_id: search.created_session_id as string | undefined,
  }),
  component: SsoCallback,
})
